import { create } from "zustand"

interface ViewingMatter {
  _id: string
  id: string // Case number like "BK-12345"
  name: string
}

interface ViewingMatterState {
  viewingMatter: ViewingMatter | null
  setViewingMatter: (matter: ViewingMatter | null) => void
  clearViewingMatter: () => void
}

export const useViewingMatterStore = create<ViewingMatterState>((set) => ({
  viewingMatter: null,
  setViewingMatter: (matter) => set({ viewingMatter: matter }),
  clearViewingMatter: () => set({ viewingMatter: null }),
}))
